export const renderInt = (price: string, decimalPlaces = 2) => price.slice(0, -(decimalPlaces + 1));
